module.exports = __webpack_public_path__ + "media/images/thumbs/atlas/vregi8-cd052955361c9348c57b9fff80431303.jpg";